/**
 * DV-2221 reorder payload assembly. The backend validates PUT .../order as an
 * exact permutation of the photoset's CURRENT assetUUIDs — which includes
 * non-photo assets (Zillow `url` type) the grid never shows, plus any photos
 * uploaded after this page loaded (the backend appends those to the list).
 * Sending only the grid's photos would 400 on any photoset with a Zillow 3D
 * tour, so this merges the grid's desired photo order into the full list:
 * non-photo entries keep their original positions, photo slots are filled
 * from the grid order, and grid photos the load-time list doesn't know
 * (fresh uploads) are appended at the end.
 */
export function buildOrderedAssetUUIDs(
  currentFullOrder: string[],
  photoAssetUUIDs: ReadonlySet<string>,
  gridOrder: string[]
): string[] {
  const queue = [...gridOrder];
  const result: string[] = [];
  for (const assetUUID of currentFullOrder) {
    if (!photoAssetUUIDs.has(assetUUID)) {
      result.push(assetUUID); // url-type / unresolvable asset: position fixed
    } else if (queue.length > 0) {
      result.push(queue.shift() as string);
    }
    // Photo slot with an exhausted queue: drop the slot. Its occupant was
    // either already emitted from the queue or is genuinely gone from the
    // grid — re-emitting the original UUID here could duplicate an entry.
  }
  result.push(...queue);
  return result;
}
